/* template */
<template><div v-on="$listeners" :class='["mpx-root-view","host-_d57fe118"]'><cube-divider/></div></template>
/* styles */
<style lang="stylus" mpxStyleOptions='{"mid":"_d57fe118"}'>
</style>

/* json */
/* script */
<script>
  import { processComponentOption, getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  var wxsModules = {}
  global.currentModuleId = "_d57fe118"
  global.currentSrcMode = "wx"
  global.currentInject = {"moduleId":"_d57fe118"}
  /** script content **/
  require("./divider-normal.mpx.js?isComponent&outputPath=components%2Fdivider-normald57fe118%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./divider-normal.mpx?ctorType=component&index=0&isComponent&lang=js&mpx&outputPath=components%2Fdivider-normald57fe118%2Findex&type=script")

  export default processComponentOption({
    option: global.__mpxOptionsMap["_d57fe118"],
    ctorType: "component",
    outputPath: "components/divider-normald57fe118/index",
    pageConfig: {},
    // @ts-ignore
    componentsMap: {'cube-divider':getComponent(require("../../../packages/mpx-cube-ui/src/components/divider/index.mpx?isComponent&outputPath=components%2Findex731ea706%2Findex"))},
    componentGenerics: {},
    genericsInfo: undefined,
    wxsMixin: getWxsMixin(wxsModules),
    hasApp: true
  })
</script>